'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Link$PvpcontrollerWeb = require("./Link.js");
var Image$PvpcontrollerWeb = require("./Image.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");

var cardHover = Css.hover({
      hd: Css.cursor(Css.pointer),
      tl: {
        hd: Css.backgroundColor(Css.hex("3c4046")),
        tl: /* [] */0
      }
    });

var card = Curry._1(Css.style, {
      hd: Css.padding(Css.px(5)),
      tl: {
        hd: Css.margin(Css.px(5)),
        tl: {
          hd: Css.border(Css.px(1), Css.solid, Css.hex("393c42")),
          tl: {
            hd: Css.width(Css.px(300)),
            tl: {
              hd: Css.maxWidth(Css.px(305)),
              tl: {
                hd: Css.height(Css.px(150)),
                tl: {
                  hd: Css.position(Css.relative),
                  tl: {
                    hd: Css.backgroundColor(Css.hex("3c4046")),
                    tl: {
                      hd: Css.borderRadius(Css.px(3)),
                      tl: {
                        hd: Css.unsafe("boxShadow", "0px 0px 12px -1px rgb(40 43 47)"),
                        tl: {
                          hd: Css.flex3(1.0, 0.0, "auto"),
                          tl: {
                            hd: cardHover,
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var name = Curry._1(Css.style, {
      hd: Css.marginLeft(Css.px(5)),
      tl: {
        hd: Css.color(Theme$PvpcontrollerWeb.subTitleColor),
        tl: {
          hd: Css.fontSize(Css.px(18)),
          tl: /* [] */0
        }
      }
    });

var image = Curry._1(Css.style, {
      hd: Css.position(Css.absolute),
      tl: {
        hd: Css.bottom(Css.px(45)),
        tl: {
          hd: Css.right(Css.px(25)),
          tl: /* [] */0
        }
      }
    });

var badImage = Curry._1(Css.style, {
      hd: Css.position(Css.absolute),
      tl: {
        hd: Css.bottom(Css.px(45)),
        tl: {
          hd: Css.right(Css.px(25)),
          tl: {
            hd: Css.width(Css.px(36)),
            tl: /* [] */0
          }
        }
      }
    });

var id = Curry._1(Css.style, {
      hd: Css.color(Css.hex("999")),
      tl: {
        hd: Css.fontSize(Css.px(15)),
        tl: {
          hd: Css.position(Css.absolute),
          tl: {
            hd: Css.bottom(Css.px(10)),
            tl: {
              hd: Css.left(Css.px(10)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var detailsHover = Css.hover({
      hd: Css.color(Css.hex("ffffff")),
      tl: /* [] */0
    });

var details = Curry._1(Css.style, {
      hd: Css.color(Css.hex("aaaaaa")),
      tl: {
        hd: Css.fontSize(Css.px(15)),
        tl: {
          hd: Css.position(Css.absolute),
          tl: {
            hd: Css.bottom(Css.px(10)),
            tl: {
              hd: Css.right(Css.px(10)),
              tl: {
                hd: detailsHover,
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var netId = Curry._1(Css.style, {
      hd: Css.color(Css.hex("848484")),
      tl: /* [] */0
    });

var dmg = Curry._1(Css.style, {
      hd: Css.color(Css.hex("848484")),
      tl: /* [] */0
    });

function ProjectileCard(Props) {
  var projectile = Props.projectile;
  var damagePercent = String(projectile.damageRatio * 100.0 | 0);
  return React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("/projectile/" + String(projectile.netId), card, React.createElement("div", undefined, React.createElement("div", {
                          className: name
                        }, projectile.name), React.createElement(Image$PvpcontrollerWeb.make, Image$PvpcontrollerWeb.makeProps(projectile.image, image, badImage, undefined, undefined, undefined)), React.createElement("div", {
                          className: id
                        }, React.createElement("span", {
                              className: netId
                            }, "NetId "), projectile.netId), React.createElement("div", {
                          className: details
                        }, damagePercent, React.createElement("span", {
                              className: dmg
                            }, "% dmg"))), undefined, undefined, undefined, undefined));
}

function makeProps(prim0, prim1, prim2) {
  var tmp = {
    projectile: prim0
  };
  if (prim1 !== undefined) {
    tmp.key = prim1;
  }
  return tmp;
}

var make = ProjectileCard;

exports.makeProps = makeProps;
exports.make = make;
/* cardHover Not a pure module */
